import _ from "lodash";

export const sortData = (data, sort) => {
    const sortKeyArr = Object.keys(sort).map((key) => key);
    const sortDirArr = Object.keys(sort).map((key) => sort[key]);

    return _.orderBy([...data], sortKeyArr, sortDirArr);
};
